// extracted by mini-css-extract-plugin
module.exports = {"useOfForceInformation":"UseOfForceInformation_useOfForceInformation__lwM_-","title":"UseOfForceInformation_title__3LepA"};